export default "__VITE_ASSET__BbPvuoWf__"